<template>
  <div :class='$style.registration'>
    <div v-if="!processing">
      <h1 :class='$style.title'>新規登録</h1>
      <p :class='$style.note'></p>

      <div :class='$style.input_group'>
        <div :class="$style.check_box_wrap">
          <base-check-box name="terms_of_service_flg" v-model="user.terms_of_service_flg" :error="v$.user.terms_of_service_flg.$invalid && v$.user.terms_of_service_flg.$dirty
            ? v$.user.terms_of_service_flg.$errors[0].$message
            : ''
            ">
            <div :class="$style.note_terms_of_service">
              <a href="/open/teams_of_service" :class="$style.a" target="_blank" rel="noopener noreferrer">
                利用規約に同意する
              </a>
            </div>
          </base-check-box>
          <base-check-box name="privacy_policy_flg" v-model="user.privacy_policy_flg" :error="v$.user.privacy_policy_flg.$invalid && v$.user.privacy_policy_flg.$dirty
            ? v$.user.privacy_policy_flg.$errors[0].$message
            : ''
            ">
            <div :class="$style.note_terms_of_service">
              <a href="https://www.j-union.co.jp/privacy/" target="_blank" rel="noopener noreferrer" :class="$style.a">
                プライバシーポリシーに同意する
              </a>
            </div>
          </base-check-box>
        </div>
      </div>
      <template v-if="hasError(errorMsgList) && !hasFieldErrorMsg(errorMsgList, ['no_attribute'])">
        <base-message type="error" v-for="(error, i) in errorMsgList" :key="i" :class="$style.msg_area">{{ error.message
          }}</base-message>
      </template>

      <div :class="$style.next_button_wrap">
        <base-button display="inline-flex" width="100%" height="50px" @click="registration" :disabled="processing"
          :bgColor="user.terms_of_service_flg && user.privacy_policy_flg ? 'green' : 'gray'">
          ユーザー登録
        </base-button>
      </div>
    </div>

    <div :class="$style.spinner" v-if="processing">
      <base-icon name="spinner" size="32px" spin />
    </div>
  </div>
</template>

<script>

import BaseButton from '@/components/base/BaseButton/BaseButton'
import BaseCheckBox from '@/components/base/BaseCheckBox/BaseCheckBox'
import BaseMessage from '@/components/base/BaseMessage/BaseMessage'
import BaseIcon from '@/components/base/BaseIcon/BaseIcon'
import useVuelidate from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
import { isFieldErrorMsg, hasError, hasFieldErrorMsg } from '@/helper/validator.js'


const requiredTeam = function () {
  if (!this.user.terms_of_service_flg) {
    return false;
  }
  return true
}

const requiredPrivacyPolicy = function () {
  if (!this.user.privacy_policy_flg) {
    return false;
  }
  return true
}

export default {
  name: 'SsoRegistration',
  components: { BaseButton, BaseCheckBox, BaseMessage, BaseIcon },
  mounted() {
    // URLのクエリパラメータからuuidを取得
    const uuid = this.$route.query.uuid;
    if (uuid) {
      this.user.uuid = uuid;
    }
  },
  data() {
    return {
      user: {
        uuid: '',
        terms_of_service_flg: false,
        privacy_policy_flg: false,
      },
      errorMsgList: [],
      processing: false
    }
  },
  setup: function () {
    return { v$: useVuelidate() }
  },
  validations: function () {
    return {
      user: {
        terms_of_service_flg: {
          required: helpers.withMessage('利用規約のチェックボックスにチェックを入れてください。', requiredTeam),
        },
        privacy_policy_flg: {
          required: helpers.withMessage('プライバシーポリシーのチェックボックスにチェックを入れてください。', requiredPrivacyPolicy),
        },
      }
    }
  },
  methods: {
    isFieldErrorMsg,
    hasError,
    hasFieldErrorMsg,

    async registration() {
      // 利用規約同意フラグのために認証基盤側のAPIにサービス名を渡す
      const service_name = 'kumiai'
      // 利用規約のversion
      const terms_of_service_version = '1.0'

      // フロント側でエラーチェック
      this.v$.$validate()
      if (this.v$.$invalid) {
        return
      }

      if (this.processing) {
        return
      }
      this.processing = true
      this.errorMsgList = []

      // 認証基盤 ユーザー登録APIコール
      await this.$axios
        .post('/api/' + this.$constants.API_VERSION + '/auth/user/saml/registration', {
          uuid: this.user.uuid,
          service_name: service_name,
          terms_of_service_flg: this.user.terms_of_service_flg,
          privacy_policy_flg: this.user.privacy_policy_flg,
          terms_of_service_version: terms_of_service_version,
        })
        .then((response) => {
          let auth_info = response.data.value

          this.$cookies.set('auth_info', {
            'tel_or_email': auth_info.tel_or_email,
            'access_token': auth_info.access_token,
            'expired_at': this.$dayjs().add(auth_info.expires_in, 's').format(),
            'refresh_token': auth_info.refresh_token
          })

          this.$store.commit('auth/setJuid', auth_info.juid)
          this.$store.commit('auth/setUserId', auth_info.user_id)

          // this.$store.state.auth.tel_or_email に登録
          this.$store.commit('auth/setTelOrEmail', auth_info.tel_or_email)

          this.switchNextRouting()

        }).catch((error) => {
          // エラーハンドリング
          if (error.response && error.response.data && error.response.data.value && error.response.data.value.errors) {
            this.errorMsgList = error.response.data.value.errors.map(error => ({
              attribute: error.attribute,
              message: error.message
            }));
          } else {
            this.errorMsgList.push({
              attribute: 'no_attribute',
              message: '不明なエラーが発生しました。'
            });
          }
        }).finally(() => {
          this.processing = false
        });
    },
    switchNextRouting: async function () {
      //user_idがない場合は強制的にプロフィール登録へ飛ばす
      if (!this.$store.state.auth.user_id) {
        await this.$router.push('/open/profile_edit')
        return //後ろの関数が走るのでreturnで終了
      }

      //ページ遷移
      const route = this.$route.query.redirect
      if (route) {
        await this.$router.push(route)
      } else {
        await this.$router.push('/home/home')
      }
    },
  }
}
</script>
<style lang='scss' module>
.registration {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 42px 32px 30px 32px;
  box-sizing: border-box;
  text-align: left;
}

.title {
  margin-top: 0;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 50px;
}

.note {
  font-size: 13px;
  color: $fontBlack;
  margin-top: 0;
  margin-bottom: 30px;
}

.note_terms_of_service {
  font-size: 13px;
  color: $fontBlack;
  padding-top: 20px;
  margin-bottom: 20px;
}

.input_group {
  &>* {
    &:nth-child(n) {
      margin-bottom: 30px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  margin-bottom: 30px;
}

.next_button_wrap {
  //margin-top: auto;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.msg_area {
  width: 100% !important;
  margin-bottom: 10px;
}

.tab_tel,
.tab_mail {
  background-color: $openBg;
  padding: 24px 16px 32px 12px;
}

.tab_input_group {
  width: 100%;
  padding: 0;
  margin: 0;

  &_item {
    display: flex;
    flex-wrap: wrap;
    font-size: 11px;

    &:not(:last-child) {
      margin-bottom: 24px;
    }

    select {
      width: 100%;
    }

    dt,
    dd {
      margin: 0;
    }

    dt {
      width: 58px;
      display: flex;
      align-items: center;
      color: $fontGray;

      &.dt_mail {
        width: 116px;
      }
    }

    dd {
      &.dd_country {
        width: calc(100% - 58px);

        select {
          width: 100%;
        }
      }

      &.dd_country_code {
        width: 46px;
        margin-right: 12px;

        input {
          padding: 0 2px;
          color: $fontGray !important;
        }
      }

      &.dd_tel {
        width: 164px;
      }

      .dd_error_message {
        font-size: 13px;
        color: $keyRed;
        margin-top: 4px;
        margin-bottom: 0;
        padding: 0;
      }

      &.dd_mail {
        width: 164px;
      }
    }
  }
}

.a {
  display: block;
  color: $keyGreen;
  font-size: 13px;

  @include mobile() {
    font-size: 11px;
  }

  &:not(:last-child) {
    margin-bottom: 16px;

    @include mobile() {
      margin-bottom: 13px;
    }
  }
}
</style>
